import getAttachments from './getAttachments';
import uploadFile from './uploadFile';
import saveFiles from './save';
import download from './download';
import archiveFile from './archiveFile';

export default [getAttachments, uploadFile, saveFiles, archiveFile, download];
